module.exports = __webpack_public_path__ + "static/WelcomeToElk7-e7c695fce393fbea043686f38dd70593.png";